import React, { useContext } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Routes from './routes'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import { UserContext } from './utils/UserContext'
import { Toaster } from 'react-hot-toast';

function App() {
  const { isLoading } = useContext(UserContext)
  if (isLoading) {
    return null
  }
  return (
    <BrowserRouter>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Routes />
      </MuiPickersUtilsProvider>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
